import React from 'react';
import EntModal from './EntModal';

export default function EntConfirmDialog({
  open,
  title,
  message,
  detail,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  busy = false,
  onConfirm,
  onClose,
}) {
  return (
    <EntModal
      open={open}
      title={title}
      onClose={busy ? undefined : onClose}
      size="sm"
      footer={
        <>
          <button type="button" className="ent-btn-secondary" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? 'ent-btn-danger' : 'ent-btn-primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </>
      }
    >
      {typeof message === 'string' ? <p className="ent-confirm-copy">{message}</p> : message}
      {detail ? <p className="ent-muted-text">{detail}</p> : null}
    </EntModal>
  );
}
